export const authInitialState = {
  nome: '',
};
